import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  owner: "",
  customer: null,
  customerList: [],
  location: "",
  vehicle: null,
  vehicleList: [],
  machineCount: "",
  hmr: "",
  category: null,
  partCode: "",
  partDesc: "",
  remarks: "",
  attachments: [],
  ticketList: [],
  refreshTime: "",
};

const ticketDocSlice = createSlice({
  name: "ticketDoc",
  initialState: initialState,
  reducers: {
    updateTicketDoc: (state = initialState, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    resetTicketDoc: (state, action) => {
      return {
        ...initialState,
        ...action.payload,
      };
    },
  },
});

export const { updateTicketDoc, resetTicketDoc } = ticketDocSlice.actions;
export default ticketDocSlice.reducer;
